/**
 * Accessibility notifications
 * @see packages/search-ui/src/A11yNotifications.js
 */
var defaultMessages = {
  moreFilters: function moreFilters(_ref) {
    var visibleOptionsCount = _ref.visibleOptionsCount,
      showingAll = _ref.showingAll;
    var message = showingAll ? "All " : "";
    message += "".concat(visibleOptionsCount, " options shown.");
    return message;
  }
};
export default defaultMessages;